import {UtilNetwork} from "@/Master/UtilNetwork";
import BigTips from "@/Master/BigTips";
import {LoginUIManager} from "@/Core/Login/LoginUIManager";
import Util from "@/Master/Util";
import {AccountSelectionDialogFC, UserType} from "@/app/_dialogs/AccountSelectionDialog/AccountSelectionDialog";
import RouterMgr from "@/Core/RouterMgr";
import LoginNetManager from "@/Core/Login/LoginNetManager";
import {API} from "@/app/_api/types/auth";
import {SDialogManagerFC} from "@/Master/SDialogFC/SDialogManagerFC";
import {PrivacyDialogFC} from "@/app/_dialogs/PrivacyDialog/PrivacyDialog";
import {NetworkDialogFC} from "@/app/_dialogs/NetworkDialog/NetworkDialog";
import EventTrack from "@/Core/EventTrack";
import UserMgr from "@/Core/UserMgr";
import GuideMgr, {GuideIDType} from "@/Core/GuideMgr";

export class StartManager {
    static TAG = "游戏启动";
    static isLogin: boolean;

    static get hasUserToken(): boolean {
        return LoginUIManager.getLastUserToken != null;
    }

    //是否用用帐号登陆过
    static get hasUser(): boolean {
        return LoginUIManager.getLastUserAccount != null && this.hasUserToken;
    }

    static onInit(): void {
        this.onStart();
    }

    static onStart() {
        if (Util.isLog){
            // console.group(this.TAG);
            console.log(this.TAG,  this.hasUserToken);
            // console.log(this.TAG, location);
        }
        EventTrack.ShowHome()

        //token 是否过期
        if (this.hasUserToken) {
            if (UserMgr.isTokenExpired){
                if (Util.isLog) console.log(this.TAG, "token已过期,重新去登陆");
                this.checkLogin();
            }else{
                if (Util.isLog) console.log(this.TAG, "已有token，不用再登陆,直接使用本地的token");
                let token = LoginUIManager.getLastUserToken;
                let userId = LoginUIManager.getLastUserId;
                let info = LoginUIManager.getLastUserInfo;
                let zipCode = LoginUIManager.getLastUserZipCode;
                let areaCode = LoginUIManager.getLastUserAreaCode;
                let loginType = LoginUIManager.getLastUserLoginType;
                let rewardType = LoginUIManager.getLastUserRewardType;
                UserMgr.updateUser('UpdateUserInfo',{
                    baseInfo:info,
                    token:token,
                    userId:userId,
                    zipCode:zipCode,
                    loginType:loginType,
                    rewardType:rewardType,
                });
                this.OnLoginSuccessful();
            }
        }else {
            this.checkLogin();
        }
    }

    static checkLogin(){
        if (this.hasUser) {
            if (Util.isLog) console.log(this.TAG, "登陆上次账户");
            this.StartLoginLastUser();
        } else {
            this.checkLoginToken();
        }
    }

    static checkLoginToken(){
        if (this.hasUserToken) return;
        this.DoLoginVisitor();
        // 先弹出用户选择登陆还是游客登陆的弹窗
        if (location.pathname == "/") {
            SDialogManagerFC.openDialog(AccountSelectionDialogFC,{
                fcKey:SDialogManagerFC.getFCKey(AccountSelectionDialogFC),
                callToLogin:(loginType:UserType)=>{
                    if (loginType === UserType.visitor) {
                        SDialogManagerFC.openDialog(PrivacyDialogFC,{
                            fcKey:SDialogManagerFC.getFCKey(PrivacyDialogFC),
                            callAccept:()=>{
                                GuideMgr.setGuideId(GuideIDType.guide_1001);
                            }
                        })
                    } else if (loginType === UserType.normal) {
                        RouterMgr.push('/login');
                    }
                }
            });

            // //前面10次统计，每5秒统计1次
            // KitBehaviour._timer.SetTimer("AccountSelectionDialog", () => {
            //     if (GuideMgr.isHowGuide){
            //
            //         KitBehaviour._timer.clearTask('AccountSelectionDialog')
            //     }
            // }, -1, 1);
        }else{
            //没有登陆的帐号返回到主页面
            // RouterMgr.push('/');
        }
    }

    // 开始登陆上一次的帐号
    static StartLoginLastUser() {
        if (!UtilNetwork.IsNetworkOk) {
            SDialogManagerFC.openDialog(NetworkDialogFC,{
                fcKey:SDialogManagerFC.getFCKey(NetworkDialogFC),
                onClose:(isOk:boolean)=>{
                    this.StartLoginLastUser();
                }
            })
            return;
        }
        const account = LoginUIManager.getLastUserAccount;
        const password = LoginUIManager.getLastUserPassword;
        const areaCode = LoginUIManager.getLastUserAreaCode;
        if (account && password && areaCode) {
            if (Util.isLog) console.log(this.TAG,'开始登陆上一次的帐号  上一次的account=' + account);
            let sendData = {} as LoginNetSendLogin;
            sendData.gaid = Util.h5UUID;
            sendData.areaCode = areaCode;
            sendData.forceQuit = "1";
            sendData.mobile = account;
            sendData.password = password;
            sendData.purchaseSwitch = `1`;
            sendData.welfareSwitch = `1`;
            LoginNetManager.Instance.SendLogin(sendData, (res: API.UserLoginResponse) => {
                if (res){
                    if (Util.isLog) console.log(this.TAG,'使用account登陆成功',res);
                }else{
                    if (Util.isLog) console.error(this.TAG,'登陆接口报错');
                    // this.DoLoginVisitor();
                }
            });
        } else {
            this.DoLoginVisitor();
        }
    }

    //开始登陆游客帐号
    static StartLoginVisitor() {
        const isUserBuy = true;
        if (Util.isLog) console.log(this.TAG, isUserBuy ? "买量-游客登陆" : "自然量-游客登陆");

        this.LoginVisitor((b) => {
            if (b) {
                this.OnLoginSuccessful();
            } else {
                if (Util.isLog) console.log(this.TAG, isUserBuy ? "买量-游客登陆-登陆失败" : "自然量-游客登陆-登陆失败");
                SDialogManagerFC.openDialog(NetworkDialogFC,{
                    fcKey:SDialogManagerFC.getFCKey(NetworkDialogFC),
                    onClose:(isOk:boolean)=>{
                        this.StartLoginVisitor();
                    }
                })
            }
        });
    }

    // 去登陆游客帐号
    static DoLoginVisitor(){
        this.LoginVisitor(b => {
            if (b) {
                BigTips.showMsg('DoLoginVisitor OnLoginSuccessful');
                this.OnLoginSuccessful();
            } else {
                SDialogManagerFC.openDialog(NetworkDialogFC,{
                    fcKey:SDialogManagerFC.getFCKey(NetworkDialogFC),
                    onClose:(isOk:boolean)=>{
                        this.DoLoginVisitor();
                    }
                })
            }
        });
    }

    // 登陆游客帐号
    static LoginVisitor(action: (open: boolean) => void) {
        if (!UtilNetwork.IsNetworkOk) {
            SDialogManagerFC.openDialog(NetworkDialogFC)
            return;
        }
        //默认都先去登陆游客帐户
        LoginNetManager.Instance.SendVistorLogin((res:API.VisitorLoginResponse)=>{
            if (res){
                if (Util.isLog) console.log(this.TAG, "游客帐户登陆成功",res);
                action(true);
            }else{
                action(false);
            }
        });

    }

    //帐登陆成功
    static OnLoginSuccessful() {
        //打点-账号登录成功时
        if (Util.isLog) {
            console.log(this.TAG, "启动页-登陆完成");
            // console.groupEnd();
        }
        StartManager.isLogin = true;
        LoginNetManager.StartUpdateToken(true);
        //todo 这里需要先强制同步ab数据和帐号风控相关的内容


        //设置需要执行顺序列表的场景
        // IapRiskPresenter.SetOrderScene(1);
        // //开始风控
        // IapRiskPresenter.TriggerIapRisk(1, ()=>{
        //     OnDataSyncComplete();
        // });
        //
        // WaitAbComplete(() => {
        //     MainInit.InitGame(() =>
        //     {
        //         IapRiskPresenter.SetCanRunOrderList(true);
        //     });
        // });

    }
}